import styled from 'styled-components'

export const BlogFeaturedResourceContainer = styled.div`
  ${(p: any) => {
    let imageStyles
    if (p.$hasImage)
      imageStyles = `
      padding-top: 147px;
        &:before {
          height: 147px;
        }
      `
    else
      imageStyles = `
        padding-top: 52px;
        &:before {
          height: 52px;
        }
    `
    return imageStyles
  }}

  max-width: 588px;
  position: relative;
  margin: 0 auto;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-image: radial-gradient(#9c9c9c 1px, transparent 0);
    background-size: 24px 24px;
    width: calc(100% + 12px);
    margin: 0 -6px;
  }

  > div {
    background: ${p => p.theme.webMktPalette.background.dark};
    text-align: center;
    padding: 24px 24px 32px;

    h6,
    p {
      color: #fff;
      margin: 0;
    }
  }

  .BlogFeaturedResource__Category {
    color: rgb(207, 216, 221);
    text-transform: uppercase;
  }

  .BlogFeaturedResource__Title {
    margin-top: 8px;
  }

  .BlogFeaturedResource__Body {
    margin-top: 16px;
  }

  .CTA {
    margin-top: 32px;
  }

  img {
    position: relative;
    margin-top: -119px;
    margin-bottom: 24px;
    width: 540px;
    object-fit: cover;
  }
`
